/*!
 * Copyright © 2005-2025 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Alfresco Example Content Application
 *
 * This file is part of the Alfresco Example Content Application.
 * If the software was purchased under a paid Alfresco license, the terms of
 * the paid license agreement will prevail. Otherwise, the software is
 * provided under the following open source license terms:
 *
 * The Alfresco Example Content Application is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The Alfresco Example Content Application is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * from Hyland Software. If not, see <http://www.gnu.org/licenses/>.
 */

/*
 * Public API Surface of aca-content
 */

export * from './lib/aca-content.module';
export * from './lib/aca-content.routes';
export * from './lib/store/initial-state';
export * from './lib/services/content-url.service';
export * from './lib/services/content-management.service';
export * from './lib/services/node-actions.service';
export * from './lib/components/info-drawer/comments-tab/external-node-permission-comments-tab.service';
export * from './lib/utils/aca-search-utils';
export * from './lib/pipes/is-feature-supported.pipe';

// Exposes pour les extensions : notre explorateur (alg-extensions) en a besoin.
// Candidat a une contribution upstream — voir docs/fork/README.md §8.
export * from './lib/services/node-actions.service';
export * from './lib/components/files/files.component';
export * from './lib/directives/document-list.directive';
export * from './lib/components/common/location-link/location-link.component';
export * from './lib/components/search/search-input/search-input.component';
export * from './lib/components/search/search-results/search-results.component';
export * from './lib/components/search/search-results-row/search-results-row.component';
export * from './lib/components/search/search-action-menu/search-action-menu.component';
export * from './lib/components/dl-custom-components/thumbnail-column/thumbnail-column.component';
export * from './lib/components/dl-custom-components/tags-column/tags-column.component';
export * from './lib/components/search/search-navigation.service';
export * from './lib/components/search/search-libraries-results/search-libraries-query-builder.service';
